import { Component, inject, TemplateRef, signal } from '@angular/core';
import { DataService } from '../services/data.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-store-token-test',
    standalone: true,
    imports: [],
    template: `
        <button type="button" class="btn btn-outline-info me-2" (click)="testTokens(modalTemplate)">
            <i class="fa-solid fa-vial me-1"></i>r2o API Test
        </button>

        <ng-template #modalTemplate>
            <div class="modal-header">
                <h4 class="modal-title pull-left">r2o API Test Ergebnis</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                @if (loading()) {
                    <div class="text-center py-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Laden...</span>
                        </div>
                        <p class="mt-2">Tokens werden geprüft, bitte warten...</p>
                    </div>
                } @else {
                    @if (failedStores().length > 0) {
                        <p>Folgende Stores haben ungültige oder nicht funktionierende Tokens</p>
                        <ul class="list-group">
                            @for (store of failedStores(); track store) {
                                <li class="list-group-item list-group-item-danger">
                                    <i class="fa-solid fa-circle-exclamation me-2"></i>{{ store }}
                                </li>
                            }
                        </ul>
                    } @else {
                        <div class="alert alert-success mb-0">
                            <i class="fa-solid fa-check-circle me-2"></i>Alle Tokens sind gültig!
                        </div>
                    }
                }
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="modalRef?.hide()">Schließen</button>
            </div>
        </ng-template>
    `
})
export class StoreTokenTestComponent {

    private dataService = inject(DataService);
    private modalService = inject(BsModalService);

    modalRef?: BsModalRef;
    failedStores = signal<string[]>([]);
    loading = signal(false);

    testTokens(template: TemplateRef<any>) {
        this.loading.set(true);
        this.failedStores.set([]);
        this.modalRef = this.modalService.show(template);

        this.dataService.request('Store/testTokens').subscribe(response => {
            this.loading.set(false);
            this.failedStores.set(response.failed_stores || []);
        }, () => {
            this.loading.set(false);
        });
    }
}
